import { FC } from "react";
import { useNavigate } from "react-router-dom";

import importSuccess from "../../../assets/fonts/importSuccess.svg";
import { Notification } from "../../../types/global/types";
import "./styles.scss";

type Props = {
  notification: Notification;
};

/**
 * "127 addresses couldn't be placed on the map. Show them to fix the addresses."
 *
 * The one-per-run summary that replaced a notification per failed address. Its whole
 * point is the LINK: the alert says how many, and the durable list of which ones lives
 * behind "Show them" — the Contacts page filtered to exactly those households.
 *
 * Without a component of its own the notification list falls through to a plain-text
 * render, which is what shipped first: the sentence appeared as one flat <h3> and
 * "Show them" was not clickable, so the notification told you a number and gave you
 * nowhere to go (caught in the browser, 2026-09-22).
 *
 * Not the map, deliberately — the owner's point is that the map carries a great deal of
 * other data and is a view, whereas this is a work queue.
 */
export const AddressesNeedAttentionNotification: FC<Props> = ({ notification }) => {
  const navigate = useNavigate();
  const title = notification.title as any;
  const path = title?.path || "/households?address_needs_attention=1";

  return (
    <div className="notification">
      <div className="notification__header">
        <div className="notification__reaction">
          <img src={importSuccess} alt="addresses" />
        </div>
        <div className="notification__title" style={{ width: "-webkit-fill-available" }}>
          <h3>
            {title?.startOfTitle}
            <button
              type="button"
              className="notification__link-button"
              onClick={() => navigate(path)}
            >
              {title?.linkText}
            </button>
            {title?.endOfTitle}
          </h3>
          <div className="notification__time">
            {notification.created_at_formatted}
          </div>
        </div>
      </div>
    </div>
  );
};
